import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import { Typography } from '@remarkable/ark-web';

import type { Subscription } from 'src/api/endpoints/storeApi.types';
import { useSubscription } from 'src/api/queries';
import { Divider, Label } from 'src/components';
import { ValueProps } from 'src/components/Offers/ValueProps';
import { StatusTag } from 'src/components/StatusTag';
import { formatDate } from 'src/utils/formatDate';
import { subscriptionHelpers } from 'src/utils/subscriptionHelpers';
import { valueProps } from 'src/utils/valueProps';

import { CardHeading } from './CardHeading';

const getActivationDate = (sub?: Subscription) => {
  switch (sub?.type) {
    case 'stripe':
      return formatDate(sub.createdAt);
    case 'free-connect':
      return null; // TODO: Update this when backend ships the data
    default:
      return null;
  }
};

export const ConnectSimpleDetails = () => {
  const subscription = useSubscription();
  const activationDate = getActivationDate(subscription.data);

  const endDate = useMemo(() => {
    if (!subscription.data || subscription.data.type !== 'stripe') return null;

    if (
      subscriptionHelpers.isDeactivated(subscription.data) ||
      subscriptionHelpers.isCancelled(subscription.data)
    ) {
      return `. Ends ${formatDate(
        subscription.data.paymentInformation.cancellationAt
      )}`;
    }
    return null;
  }, [subscription.data]);

  return (
    <div data-cy="subscription-card-activated">
      <div className="flex flex-row items-start justify-between gap-8">
        <div>
          <CardHeading>
            <Trans>Connect</Trans>
          </CardHeading>
          <Label
            className="inline-block"
            data-cy="subscription-card-activated-label"
          >
            <Trans>
              Activated {activationDate} {endDate}
            </Trans>
          </Label>
        </div>

        <StatusTag
          size="fluid"
          subscription={subscription.data}
          data-cy="subscription-status-tag"
        />
      </div>

      <Divider className="my-16" />

      <div>
        <Typography variant="body-lg">
          <Trans>
            Enjoy unlimited cloud storage, seamless integrations, handwriting
            search, and a growing list of tools built to suit your workflow.
          </Trans>
        </Typography>

        <div
          data-cy="connect-offer-perks"
          className="mt-24 flex flex-col gap-16 md:flex-row"
        >
          <ValueProps
            className="justify-start"
            valueProps={valueProps.connect}
          />
        </div>
      </div>
    </div>
  );
};
